"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _modal = _interopRequireDefault(require("@amzn/meridian/modal"));
var _column = _interopRequireDefault(require("@amzn/meridian/column"));
var _text = _interopRequireDefault(require("@amzn/meridian/text"));
var _divider = _interopRequireDefault(require("@amzn/meridian/divider"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _FeedbackConstants = require("../constants/FeedbackConstants");
var _RequiredQuestionTypeComponentList = _interopRequireDefault(require("./RequiredQuestionTypeComponentList"));
var _SkippableFooter = _interopRequireDefault(require("./SkippableFooter"));
var _NonSkippableFooter = _interopRequireDefault(require("./NonSkippableFooter"));
var TriggeredFeedback = function TriggeredFeedback(_ref) {
  var open = _ref.open,
    isDisabled = _ref.isDisabled,
    onClose = _ref.onClose,
    onClickFooterButton = _ref.onClickFooterButton,
    title = _ref.title,
    description = _ref.description,
    questions = _ref.questions,
    submitButtonSize = _ref.submitButtonSize,
    submitButtonType = _ref.submitButtonType,
    submitButtonText = _ref.submitButtonText,
    isSkippable = _ref.isSkippable,
    prePopulate = _ref.prePopulate;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_modal["default"], {
    title: title,
    open: open,
    scrollContainer: "viewport",
    closeLabel: "Close",
    describedById: "modal-description",
    width: "700px"
  }, /*#__PURE__*/_react["default"].createElement(_column["default"], {
    spacingInset: "medium"
  }, /*#__PURE__*/_react["default"].createElement(_text["default"], {
    id: "modal-description"
  }, description), /*#__PURE__*/_react["default"].createElement(_divider["default"], {
    size: "small"
  }), /*#__PURE__*/_react["default"].createElement(_RequiredQuestionTypeComponentList["default"], {
    questions: questions,
    prePopulate: prePopulate
  })), /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isSkippable ? /*#__PURE__*/_react["default"].createElement(_SkippableFooter["default"], {
    onClose: onClose,
    isDisabled: isDisabled,
    onClickFooterButton: onClickFooterButton,
    submitButtonSize: submitButtonSize,
    submitButtonText: submitButtonText,
    submitButtonType: submitButtonType
  }) : /*#__PURE__*/_react["default"].createElement(_NonSkippableFooter["default"], {
    isDisabled: isDisabled,
    onClickFooterButton: onClickFooterButton,
    submitButtonSize: submitButtonSize,
    submitButtonText: submitButtonText,
    submitButtonType: submitButtonType
  }))));
};
TriggeredFeedback.propTypes = {
  open: _propTypes["default"].bool.isRequired,
  isDisabled: _propTypes["default"].bool.isRequired,
  onClose: _propTypes["default"].func.isRequired,
  onClickFooterButton: _propTypes["default"].func.isRequired,
  questions: _propTypes["default"].array.isRequired,
  title: _propTypes["default"].string,
  description: _propTypes["default"].string,
  submitButtonSize: _propTypes["default"].string,
  submitButtonType: _propTypes["default"].string,
  submitButtonText: _propTypes["default"].string,
  isSkippable: _propTypes["default"].bool,
  prePopulate: _propTypes["default"].object.isRequired
};
TriggeredFeedback.defaultProps = {
  title: _FeedbackConstants.FEEDBACK_FORM_PROPERTIES.title,
  description: _FeedbackConstants.FEEDBACK_FORM_PROPERTIES.description,
  submitButtonSize: _FeedbackConstants.SUBMIT_BUTTON_PROPERTIES.size,
  submitButtonType: _FeedbackConstants.SUBMIT_BUTTON_PROPERTIES.type,
  submitButtonText: _FeedbackConstants.SUBMIT_BUTTON_PROPERTIES.text,
  isSkippable: true
};
var _default = exports["default"] = TriggeredFeedback;
//# sourceMappingURL=TriggeredFeedback.js.map